// A DataGrid cell with no renderCell sets title={value}, and telemetry names a click after that title.
export const DD_GRID_CELL_SLOT_PROPS = { 'data-dd-action-name': 'Grid cell' };

export const REDACTED = 'REDACTED';

// Matched anywhere, not per parameter: tokens arrive nested in redirectTo and encoded in beacon URLs.
const SECRET_PARAM =
  /((?:^|[?&;#]|%3f|%26|%23|%3b)[a-z0-9_-]*(?:token|x-amz-signature|x-amz-credential)(?:=|%3d))[^&;#)\s]*/gi;

// Returns a string for every input: the RUM SDK discards a non-string write-back and sends the original.
export const scrubUrl = (value: unknown): string => {
  if (typeof value !== 'string') return '';
  if (!/[=?&;#]|%3f|%26|%23|%3b|%3d/i.test(value)) return value;

  return value.replace(SECRET_PARAM, `$1${REDACTED}`);
};

// Not the global pattern: test() on it resumes from the previous match and answers false every other call.
const CARRIES_SECRET = new RegExp(SECRET_PARAM.source, 'i');

export const urlCarriesSecret = (url: string): boolean => CARRIES_SECRET.test(url);
